import { FC } from 'react';
import { buildImageSource, buildImageSourceSet } from '../../../../../utils/buildImageSource';
import { pluralize } from '../../../../../utils/pluralize';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconImage } from '../../../../icon/IconImage';
import { Box } from '../../../../layout/Box';
import { Image } from '../../../../media/Image';
import { MediaCover } from '../../../../media/MediaCover';
import { Typography } from '../../../../typography/Typography';
import { ListItem } from '../../styles';
import { CollectionListItemProps } from './types';

export const CollectionListItem: FC<CollectionListItemProps> = ({ collection, onClick }) => {
    const preview = collection.previewItems[0];
    const t = useTranslation();

    const publicStatusText = t(collection.isPublic ? 'Публичная' : 'Секретная');
    const numberOfPostText = pluralize(
        collection.numberOfPosts,
        '%d пост',
        '%d поста',
        '%d постов',
    );

    return (
        <ListItem p={1} role="button" onClick={onClick}>
            <MediaCover width={48} minWidth={48} height={48} borderRadius={1}>
                {preview?.type === 'image' && (
                    <Image
                        src={buildImageSource(preview.media, 'grid')}
                        srcSet={buildImageSourceSet(preview.media, 'grid')}
                    />
                )}
                {preview?.type === 'video' && <Image src={preview.media[0].firstFrameUrl} />}
                {!preview && <IconImage fill="var(--color-primary)" />}
            </MediaCover>
            <Box>
                <Typography variant="body" weight="medium">
                    {collection.displayName}
                </Typography>
                <Typography variant="caption" color="secondary">
                    {`${publicStatusText}・${numberOfPostText}`}
                </Typography>
            </Box>
        </ListItem>
    );
};
